import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { logger } from '@/utils/logger/logger';
import { type ButtonAction } from '@heidi/runtime/analytics-vocabulary';
import { sanitizeError } from '@heidi/runtime/logger';

/**
 * The `TrackedButton` emit: `button_clicked` with the action and the button's
 * visible label only (no screen name), Snowplow + Datadog. A failed emit is
 * logged and swallowed so a click never throws.
 */
export function trackUnscopedButtonClicked(action: ButtonAction, label: string): void {
  try {
    track({
      event_name: TrackingEventName.ButtonClicked,
      props: { action, label },
      // button_clicked is Snowplow + Datadog only — keep it off
      // Amplitude, matching the trackButtonClicked chokepoint policy.
      options: { amplitude: false },
    });
  } catch (err) {
    // A classification only: a non-Error throw would be stringified verbatim.
    logger.error('Failed to track button_clicked', {
      ...sanitizeError(err),
      error_name: err instanceof Error ? err.name : typeof err,
    });
  }
}
